"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountyColumnHandler = getCountyColumnHandler;
exports.getEthnicityColumnHandler = getEthnicityColumnHandler;
exports.getGenderColumnHandler = getGenderColumnHandler;
exports.getRegionColumnHandler = getRegionColumnHandler;
exports.getRegisterStateColumnHandler = getRegisterStateColumnHandler;
exports.getStateTerritoryColumnHandler = getStateTerritoryColumnHandler;
exports.getStateColumnHandler = getStateColumnHandler;
exports.getTerritoryColumnHandler = getTerritoryColumnHandler;
const mapAdvancedSearchOpToStringColumnFilter_1 = require("../../advanced-search/utils/mapAdvancedSearchOpToStringColumnFilter");
const getColumnsHandlerTypeId_1 = require("./getColumnsHandlerTypeId");
const getColumnsHandlerTypeString_1 = require("./getColumnsHandlerTypeString");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getCountyColumnHandler(countyValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(countyValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'name',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'county' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
function getEthnicityColumnHandler(ethnicityValueProvider) {
    return (0, getColumnsHandlerTypeId_1.getColumnsHandlerTypeId)(ethnicityValueProvider, {
        subFilterEntity: 'ethnicity',
        onGetStorageSubFilter: (operator, value) => (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
    });
}
function getGenderColumnHandler(genderValueProvider) {
    return (0, getColumnsHandlerTypeId_1.getColumnsHandlerTypeId)(genderValueProvider, {
        subFilterEntity: 'gender',
        onGetStorageSubFilter: (operator, value) => (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRegionColumnHandler(regionValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(regionValueProvider, params, {
        subFilterEntity: 'region',
        subFilterColumn: 'name',
        onGetStorageSubFilter: (operator, value) => (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRegisterStateColumnHandler(registerStateValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(registerStateValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'state' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getStateTerritoryColumnHandler(stateTerritoryValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(stateTerritoryValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [
                { column: 'type', op: 'in', value: ['state', 'territory'] },
                (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value),
            ],
        }),
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getStateColumnHandler(stateValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(stateValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'state' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getTerritoryColumnHandler(territoryValueProvider, params = {}) {
    return (0, getColumnsHandlerTypeString_1.getColumnsHandlerTypeString)(territoryValueProvider, params, {
        subFilterEntity: 'jurisdiction',
        subFilterColumn: 'postalCode',
        onGetStorageSubFilter: (operator, value) => ({
            op: 'and',
            filter: [{ column: 'type', op: '=', value: 'territory' }, (0, mapAdvancedSearchOpToStringColumnFilter_1.mapAdvancedSearchOpToStringColumnFilter)('name', operator, value)],
        }),
    });
}
